export default __webpack_public_path__ + "static/AnantG-05d7312a723c1c11ef86d1de8fc2051a.png";